import React from 'react';
import {Button, Dialog, DialogTitle, DialogActions, DialogContent} from '@mui/material';
import {useQuery} from '@apollo/client';
import AutoField from '../AutoForm/AutoFieldNew';
import {
  businessUnitIdsField,
  everythingField,
  permissionOverrideField,
  globalPermissionsField,
  groupField,
} from './fields';
import withAutoFormNew from '../AutoForm/AutoFormNew';
import {getBusinessUnitsQuery} from '../../contexts/useAuthContext';
import {GetBusinessUnits} from '../../schema-types/GetBusinessUnits';
import {useAutoForm} from '../AutoForm/useAutoForm';
import {
  FilterFormValue,
  usePermissionsAuditContext,
} from '../../pages/PermissionsAuditPage/PermissionsAuditProvider';
import {UPDATES} from '../../shared/UPDATES';

type PermissionsFilterDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const PermissionsFilter: React.FC<PermissionsFilterDialogProps> = ({
  open,
  onClose,
}) => {
  const {data} = useQuery<GetBusinessUnits>(getBusinessUnitsQuery);
  const {values, setValues} = useAutoForm<FilterFormValue>();
  const {initialState, setState} = usePermissionsAuditContext();

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Permission Filters</DialogTitle>
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AutoField field={everythingField} />
        <AutoField field={{...permissionOverrideField, disabled: values.everything}} />
        <AutoField field={{...groupField, disabled: values.everything}} />
        <AutoField
          field={{
            ...businessUnitIdsField,
            options:
              data?.businessUnits?.map((x) => ({
                value: x?.id || 'N/A',
                label: x?.name || 'N/A',
              })) || [],
            disabled: values.everything,
          }}
        />
        <AutoField field={{...globalPermissionsField, disabled: values.everything}} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setValues(UPDATES._4850, {...initialState});
            setState((prevState) => ({...initialState, search: prevState.search}));
          }}
          color="secondary"
          variant="outlined"
        >
          Clear all filters
        </Button>
        <Button
          onClick={() => {
            setState((prevState) => ({
              ...prevState,
              ...values,
            }));
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const PermissionsFilterDialog = withAutoFormNew<
  FilterFormValue,
  PermissionsFilterDialogProps
>(PermissionsFilter, undefined, {debugPosition: 'bottom'});
